
// This file maps internal feature keys to the string values sent by the API
// You can change the string values inside the double quotes ("") to match your API response
export const FEATURES = {
  MATCHED_PROPERTY: "MATCHED_PROPERTY",
  SAVED_PROPERTY: "SAVED_PROPERTY",
  BUILDER_PROPERTY: "BUILDER_PROPERTY",
  AGENT_REQUIREMENT: "AGENT_REQUIREMENT",
  OWNER_PROPERTY: "OWNER_PROPERTY",
  BROKER_PROPERTY: "BROKER_PROPERTY",
  STAFF_MANAGEMENT: "STAFF_MANAGEMENT"
};

export const ADDONS = {
  SUBUSER_LIMIT: "Sub1010",
  OWNER_PROPERTY: "Owner1010",
  BROKER_PROPERTY: "Broker1010",
  BUILDER_PROPERTY: "Builder1010",
  SAVED_PROPERTY: "Saved1010",
  MATCHED_PROPERTY: "Matched1010",
  CONATCT_CREDIT: "Credit1010"
};


export const PLAN_ADDONS = {
 SUBUSER_LIMIT: "Sub1010",
  OWNER_PROPERTY: "Owner1010",
  BROKER_PROPERTY: "Broker1010",
  BUILDER_PROPERTY: "Builder1010",
  VERIFIED_LISTING: "Verified1010"
}

// Verify Listing credit packs. Shared by the standalone Verify Listing purchase
// flow (GeotagPhotos) and the Verified Listings add-on in subscription checkout.
export const VERIFY_LISTING_PRICING = {
  "6M": { amount: 999, credits: 1200, label: "1,200 credits" },
  "12M": { amount: 1499, credits: 3000, label: "3,000 credits" },
};

export const DEFAULT_VERIFY_LISTING_PLAN_CODE = "6M";

export const DemoAccount = {
  DEMO_ACCOUNT: "Demo Account"
}